import reducers from './reducers/';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
;
export default function configStore(initialState) {
    return createStore(reducers, initialState, applyMiddleware(thunk))
}
